import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-baidu",
  "use": "icon-baidu-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-baidu\">\n<style type=\"text/css\">\n\t#icon-baidu .st0{fill:#F54D3E;}\n</style>\n<path class=\"st0\" d=\"M141.2,119.6L141.2,119.6c0,0-12.9,12.8-23.3,28c-10.3,15.2-12.2,29.5-13.6,33.4c-1.5,3.9-4.3,3.5-4.3,3.5\n\ts-2.8,0.4-4.3-3.5c-1.5-3.9-3.3-18.2-13.6-33.4c-10.3-15.2-23.3-28-23.3-28l0,0c-11.7-11-19-26.6-19-43.9c0-33.3,27-60.2,60.2-60.2\n\ts60.2,27,60.2,60.2C160.2,93,152.9,108.6,141.2,119.6z M138.1,64.1h-10.6v27.2h-10.1c0,0-3.2-0.5-3.8-3.1V63.9l-9.9,0.2v27\n\tc0,0,0.5,6.7,9.9,9.2h24.4L138.1,64.1z M98.5,49.1L88.9,49v13.9H77.6c0,0-11.3,0.9-15.3,13.8c-1.4,8.6,1.2,13.6,1.7,14.7\n\tc0.5,1.1,4.1,7.3,13.3,9.2h21.2L98.5,49.1z M88.7,92h-8.6c0,0-6-0.3-7.8-7.2c-0.9-3.1,0.1-6.6,0.6-7.9c0.5-1.4,2.4-4.6,6.6-5.8h9.2\n\tV92z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/baidu.svg
// module id = cvyf
// module chunks = 3